/**
 * Constantes centralizadas para tratamento de erros de importação
 */

/**
 * Tipos de erro de importação suportados
 */
export const IMPORT_ERROR_TYPES = {
  NO_COOPERATORS: 'noCooperators',
  SHEET_SCREEN_MISMATCH: 'sheetScreenMismatch',
  DUPLICATE_COOPERATORS: 'duplicateCooperators',
  COST_ALLOWANCE_PRESENT: 'costAllowancePresent',
  MISSING_COLUMNS: 'missingColumns',
  HIRING_MODEL_MISMATCH: 'hiringModelMismatch',
  UNKNOWN: 'unknown',
};
